






import { Vue, Component, Prop } from "vue-property-decorator"
import { isExternal } from "@/utils/validate"
@Component({})
export default class Link extends Vue {
    @Prop({ type: String, required: true }) to!: string
    linkProps(url: string) {
        if (isExternal(url)) {
            return {
                is: "a",
                href: url,
                target: "_blank",
                rel: "nopener"
            }
        }
        return {
            is: "router-link",
            to: url
        }
    }
}
